import { Stack } from '@mui/material';

import AboutDeck from '@/components/home/AboutDeck';
import HeroSection from '@/components/home/HeroSection';
import HowItWorks from '@/components/home/HowItWorks';
import SpreadsOverview from '@/components/home/SpreadsOverview';

import { homeStackSx } from './Home.styles';

function Home() {
  return (
    <Stack spacing={6} sx={homeStackSx}>
      <HeroSection />
      <SpreadsOverview />
      <AboutDeck />
      <HowItWorks />
    </Stack>
  );
}

export default Home;
